import apiClient from "../../../api/apiClient";

// ================= GET ALL =================
// ================= GET ALL =================
export const getServiceCallsApi =
  async (

    page: number,

    pageSize: number,

    search: string,

    tenantId: string,

    state?: number | null,

    unAssignedTechnician?: boolean,

  ) => {

    const res =
      await apiClient.get(
        "/service-calls",
        {
          params: {

            PageNumber:
              page,

            PageSize:
              pageSize,

            Search:
              search,

            TenantId:
              tenantId,

            tenantId,

            State:
              state,

            UnAssignedTechnician:
              unAssignedTechnician,

          },
        }
      );

    return res.data;

  };

// ================= CREATE =================
export const createServiceCallApi =
  async (
    data: any,
    tenantId: string
  ) => {

    const res =
      await apiClient.post(
        "/service-calls",
        data,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

  // ================= GET BY ID =================
export const getServiceCallByIdApi =
  async (
    id: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        `/service-calls/${id}`,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= UPDATE =================
export const updateServiceCallApi =
  async (
    data: any,
    tenantId: string
  ) => {

    const res =
      await apiClient.put(
        "/service-calls",
        data,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= DELETE =================
export const deleteServiceCallApi =
  async (
    id: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.delete(
        `/service-calls/${id}`,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };